import type { Select } from '@table-library/react-table-library/select'
import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { Condition } from 'features/conditions/molecules/Condition/Condition'
import type { Option } from 'shared/components/ContextMenu/types'
import type { ConditionsRes } from 'features/conditions/types/conditions.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	conditions: ConditionsRes
	select: Select
	menuOptions: Option[]
}

export const TableSection = ({ conditions, select, menuOptions }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ menuOptions })

	const results = conditions.data.results
	const isPaginated = !!(conditions.data.next || conditions.data.previous)

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((condition) => (
						<Condition key={condition.id} condition={condition} menuOptions={menuOptions} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={false}
					select={select}
					customStyles={getCardTableStyles(columns, { clickableRows: false })}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground">
				<span>
					{isPaginated
						? t('{{ count }} entries', { count: results.length })
						: t('{{ count }} of {{ total }} entries', {
								count: results.length,
								total: results.length
							})}
				</span>
				<Pagination
					prev={conditions.data.previous}
					next={conditions.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
